import type { ItemUserModel } from '@shared/models/itemUser.model';

export const sortDataForUserList = (users: ItemUserModel[], owner: ItemUserModel): ItemUserModel[] => {
  let formattedArr = [];

  if (users.findIndex((item) => item?.id === owner?.id) >= 0) {
    formattedArr = users
      .map((item) => (item?.id === owner?.id ? { ...item, isOwner: true } : item))
      .sort((x, y) => {
        return x.isOwner === true ? -1 : y.isOwner === true ? 1 : 0;
      });
  } else {
    formattedArr = [...users, { ...owner, isOwner: true }].sort((x, y) => {
      return x.isOwner === true ? -1 : y.isOwner === true ? 1 : 0;
    });
  }

  return formattedArr;
};
